<template>
    <div class="flex-taxonomy-data">
        <div class="flex-taxonomy-data__form">
            <div>
                <h2 class="flex-form__section-title">
                    Taxonomy Categories
                </h2>

                <taxonomy-category
                    v-for="(category) in tags"
                    :key="category.id"
                    :category="category"
                    @deleted="categoryDeleted"
                />
            </div>
            <section>
                <button class="flex-taxonomy-data__button--add" @click="addNewCategory()">+ ADD NEW CATEGORY</button>
            </section>
        </div>

        <div class="flex-taxonomy-data__buttons">
            <button
                class="flex-taxonomy-data__button flex-taxonomy-data__button--continue"
                @click="save"
            >
                {{ submitButtonText }}
            </button>

            <button
                class="flex-taxonomy-data__button flex-taxonomy-data__button--cancel"
                @click="cancel"
            >
                CANCEL
            </button>
        </div>
    </div>
</template>

<script>
import TaxonomyCategory from '@/components/page-editor/shared/taxonomy/taxonomy-category';
import { TaxonomyData } from '@/data/data-models';

export default {
    name: 'taxonomy-data',

    components: {
        TaxonomyCategory,
    },

    props: {
        submitButtonText: {
            type: String,
            default: 'SAVE',
        },

        data: {
            type: Object,
            default: () => ({}),
        },

        editMode: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            tags: [],
        };
    },

    watch: {
        data(val) {
            this.setData(val);
        },
    },

    beforeMount() {
        this.setData(this.data);
    },

    methods: {
        save() {
            const data = new TaxonomyData(this.tags);
            this.$emit('save', data);
        },

        cancel() {
            this.$emit('cancel');
        },

        setData(data) {
            this.tags = data.tags;
            if (!this.tags || this.tags.length === 0) {
                this.tags = [];
            }
        },

        addNewCategory() {
            this.tags.push(this.getNewCategory());
        },

        getNewCategory() {
            return { name: '', tags: [], id: '' };
        },

        categoryDeleted(category) {
            if (category && this.tags && this.tags.length > 0) {
                this.tags.splice(this.tags.indexOf(category), 1);
            }
        },
    },
};
</script>

<style lang="scss">
.flex-taxonomy-data {
    margin: 25px 35px 75px;

    &__form {
        max-width: 100%;
        margin-bottom: 40px;
    }

    &__buttons {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;

        display: flex;
        padding: 0;
        margin: 0;
        z-index: 10;
    }

    &__category-name {
        font-size: large;
        margin-right: 10px;
    }

    &__category {
        border: 1px solid var(--form-inputBorderColor);
        padding: 10px;
    }

    &__column--1  {
        display: flex;
        width: 50%;
    }

    &__column--2  {
        display: flex;
        width: 50%;
    }

    &__button {
        flex-grow: 1;
        z-index: 2; // issue with z-index for toggles going over button
        min-height: 50px;

        &--continue {
            @extend %button;
        }

        &--cancel {
            @extend %button-alt;
        }

        &--add {
            @extend %button;
            background-color: var(--form-buttonBackgroundColor);
            max-width: fit-content;
        }
    }

    &__tag {
        background-color: var(--form-buttonBackgroundColor);
        padding: 5px 0px 5px 5px;
        margin: 5px;
        text-align: center;
        font-size: larger;
        display: inline-block;
    }

    &__tag-delete {
        margin-left: 4px;
        font-size: small;
        background-color: var(--form-buttonHoverBackgroundColor);
        padding: 4px 6px;
        cursor: pointer;
    }

    &__autocomplete {
        position: relative;
        background-color: var(--navbar-color);
    }

    &__autocomplete-results {
        position: absolute;
        left: 0;
        right: 0;
        border: 1px solid var(--form-inputBorderColor);
        background-color: var(--form-inputBackgroundColor);
        opacity: 1;
        z-index: 1000;
    }

    &__autocomplete-result {
        list-style: none;
        text-align: left;
        padding: 4px 6px;
        cursor: pointer;
    }

    &__autocomplete-result:hover {
        background-color: var(--form-inputBorderColor);
        color: var(--app-color);
    }
}
</style>
